const LoginResultType = {
    Success: 1,
    Failed:  2,
    MissingInfo: 3 
};

export default LoginResultType;